import permissions from '~/data/permissions/router-permissions'

export const checkRoutePermission = async (routeName: string, noAuthenticatedRedirect: boolean = false) => {
  const store = $store()
  const workspaceId = computed(() => store.auth.workspaceId)
  const workspaceType = computed(() => store.auth.workspaceType)
  const companyType = computed((): string | undefined => store.auth.companyType)
  const cCooperatorTypes = computed((): string[] | undefined => store.auth.cooperatorTypes)
  const isAdmin = computed(() => store.userConfig.isAdmin)

  if (!workspaceId.value) {
    const workspaces = store.userConfig.workspaces
    const router = useRouter()
    const id = computed(() => router.currentRoute?.value?.params?.id)
    const workspace = workspaces.find((w: any) => w._sid === id.value)

    if (workspace) {
      const { _sid, companyType, timezone, type, cooperatorTypes } = workspace
      store.auth.setWorkspace({ id: _sid, companyType, timezone, type, cooperatorTypes })
      await new Promise((resolve: any) => {
        setTimeout(() => resolve(), 300)
      })
    }
  }

  let prefix = 'trucker-id-'

  if (companyType.value && ['PARTNER'].includes(companyType.value)) {
    const partnerPrefixes = ['pp-id-', 'pc-id-']
    partnerPrefixes.forEach((p) => {
      routeName = routeName.replace(p, '')
    })
    prefix = '' // Không cần prefix nữa
  }

  if (workspaceType.value === 'IMPORT_AND_EXPORT') {
    routeName = routeName.replace('c-id-', '')
    prefix = '' // Không cần prefix nữa
  }

  if (routeName.startsWith('trucker-admin')) {
    routeName = routeName.replace('trucker-admin-id-', '')
    prefix = ''
  }

  // Nếu còn prefix, thay thế nó
  if (prefix) {
    routeName = routeName.replace(prefix, '')
  }

  let pass: boolean = false
  if (!permissions[routeName]) {
    pass = true
  } else {
    const needPermissions = permissions[routeName]

    pass = checkPermission(needPermissions)
  }

  if (noAuthenticatedRedirect) {
    if (!pass) {
      if (workspaceId.value && typeof workspaceId.value === 'string') {
        if (workspaceType.value === 'VENDOR') {
          switch (companyType.value) {
            case 'OWNER':
              // return navigateTo({
              //   name: 'trucker-id',
              //   params: { id: workspaceId.value }
              // })
              return
            case 'PARTNER':
              if (cCooperatorTypes.value?.includes('PARTNER')) {
                return navigateTo({
                  name: 'pp-id',
                  params: { id: workspaceId.value }
                })
              } else if (cCooperatorTypes.value?.includes('CUSTOMER')) {
                // Sửa lỗi chính tả nếu cần
                return navigateTo({
                  name: 'pc-id',
                  params: { id: workspaceId.value }
                })
              }
              break
            default:
              break
          }

          return navigateTo({
            // name: 'workspace-list'
            name: 'user-search-booking'
          })
        }

        if (workspaceType.value === 'IMPORT_AND_EXPORT') {
          switch (companyType.value) {
            case 'OWNER':
              return navigateTo({
                name: 'c-id',
                params: { id: workspaceId.value }
              })
            default:
              return navigateTo({
                // name: 'workspace-list'
                name: 'user-search-booking'
              })
          }
        }
      }

      if (isAdmin.value) {
        return navigateTo({
          name: 'admincp'
        })
      }

      return navigateTo({
        // name: 'workspace-list'
        name: 'user-search-booking'
      })
    }
  }
  if (!pass) {
    return abortNavigation()
  }
}

export const checkPermission = (needPermissions?: string | Array<string>, justOnePermission?: Boolean): boolean => {
  try {
    if (typeof needPermissions === 'string') {
      needPermissions = [needPermissions]
    }
    if (!(needPermissions || Array.isArray(needPermissions))) {
      return true
    }
    const store = $store()
    const routeName = useRoute()?.name?.toString() || ''

    const group = store.system.getGroup

    const user = store.userConfig.getUser

    if (routeName.includes('admincp')) {
      if (user?.isAdmin && checkPermissionAdmin(needPermissions)) {
        return true
      }
    } else if (group?.isAdmin) {
      return true
    }

    // if (!needPermissions || !needPermissions.length || !Array.isArray(needPermissions)) {
    //   return false
    // }

    if (!group || !group.permissions || !Array.isArray(group.permissions)) {
      group.permissions = []
    }

    const valid = needPermissions.map((permission) => group.permissions?.includes(permission))

    if (justOnePermission) {
      if (valid.includes(true)) {
        return true
      }
    }

    return !valid.includes(false)
  } catch (e: any) {
    return true
  }
}

export const checkPermissionAdmin = (needPermissions: string | Array<string>, justOnePermission?: Boolean): boolean => {
  try {
    if (!needPermissions) {
      return true
    }

    const store = $store()
    const user = store.userConfig.getUser
    if (!Array.isArray(needPermissions)) {
      needPermissions = [needPermissions]
    }

    if (user.roles.includes('super')) {
      return true
    }

    const valid = needPermissions.map((permission) => user.roles?.includes(permission))

    if (justOnePermission) {
      if (valid.includes(true)) {
        return true
      }
    }

    return !valid.includes(false)
  } catch (e: any) {
    return false
  }
}
